import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,{staticClass:"cover"},[_c(VCardText,[_c(VRow,[_c(VCol,[_c(VImg,{staticClass:"mt-12",attrs:{"src":require("@/assets/images/404-white.svg"),"lazy-src":require("@/assets/images/404-white.svg"),"height":"400","contain":""}})],1)],1),_c(VRow,[_c(VCol,{staticClass:"text-center"},[_c(VBtn,{attrs:{"to":"/"}},[_vm._v("Back to home")])],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }